import type { NoteListItem } from '@/types/note-list';

function daysAgo(days: number): string {
  return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
}

/**
 * Demo notes for the master notes screen, spread across all five note domains so
 * mixed-domain selection and per-domain row actions can be exercised in demo mode.
 */
export const mockNotesList: NoteListItem[] = [
  {
    noteId: 9001,
    entityType: 'customer',
    entityId: 1,
    entityReference: 'Acme Corporation',
    customerId: 1,
    customerName: 'Acme Corporation',
    customerAccountNumber: 'ACC-1001',
    noteType: 'general',
    content: 'Spoke to accounts payable — remittance advice will be emailed by Friday.',
    isPrivate: false,
    isPinned: true,
    createdByUserId: 11,
    createdByName: 'Sarah Johnson',
    createdAt: daysAgo(1),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9002,
    entityType: 'transaction',
    entityId: 501,
    entityReference: 'INV-2024-002',
    customerId: 1,
    customerName: 'Acme Corporation',
    customerAccountNumber: 'ACC-1001',
    noteType: 'general',
    content: 'Invoice disputed on delivery quantity; awaiting proof of delivery from the warehouse.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: 12,
    createdByName: 'Mike Chen',
    createdAt: daysAgo(2),
    updatedByName: 'Mike Chen',
    updatedAt: daysAgo(1),
  },
  {
    noteId: 9003,
    entityType: 'case',
    entityId: 77,
    entityReference: 'CASE-000077',
    customerId: 2,
    customerName: 'Globex Ltd',
    customerAccountNumber: 'ACC-1002',
    noteType: 'case_creation',
    content: 'Escalated to stage 3 after two missed callbacks.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: null,
    createdByName: 'System',
    createdAt: daysAgo(3),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9004,
    entityType: 'promise',
    entityId: 42,
    entityReference: 'PTP-42',
    customerId: 2,
    customerName: 'Globex Ltd',
    customerAccountNumber: 'ACC-1002',
    noteType: 'partial_payment',
    content: 'Customer promised payment of 12,500.00 by the end of the month.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: 11,
    createdByName: 'Sarah Johnson',
    createdAt: daysAgo(4),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9005,
    entityType: 'dispute',
    entityId: 18,
    entityReference: 'DSP-018',
    customerId: 3,
    customerName: 'Initech Systems',
    customerAccountNumber: 'ACC-1003',
    noteType: 'closure',
    content: 'Credit note raised for the duplicated shipping charge; dispute can be closed once approved.',
    isPrivate: true,
    isPinned: false,
    createdByUserId: 13,
    createdByName: 'Emma Wright',
    createdAt: daysAgo(5),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9006,
    entityType: 'customer',
    entityId: 3,
    entityReference: 'Initech Systems',
    customerId: 3,
    customerName: 'Initech Systems',
    customerAccountNumber: 'ACC-1003',
    noteType: 'general',
    content: 'Credit limit review scheduled — bureau score dropped two bands this quarter.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: null,
    createdByName: 'System',
    createdAt: daysAgo(7),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9007,
    entityType: 'transaction',
    entityId: 502,
    entityReference: 'INV-2024-014',
    customerId: 4,
    customerName: 'Umbrella Retail',
    customerAccountNumber: 'ACC-1004',
    noteType: 'general',
    content: 'Payment plan agreed over three instalments starting next week.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: 12,
    createdByName: 'Mike Chen',
    createdAt: daysAgo(9),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9008,
    entityType: 'case',
    entityId: 78,
    entityReference: 'CASE-000078',
    customerId: 4,
    customerName: 'Umbrella Retail',
    customerAccountNumber: 'ACC-1004',
    noteType: 'case_creation',
    content: 'Left voicemail with the finance director; will retry Monday morning.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: 11,
    createdByName: 'Sarah Johnson',
    createdAt: daysAgo(11),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9009,
    entityType: 'promise',
    entityId: 43,
    entityReference: 'PTP-43',
    customerId: 5,
    customerName: 'Soylent Foods',
    customerAccountNumber: 'ACC-1005',
    noteType: 'broken',
    content: 'Promise broken — direct debit returned unpaid.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: null,
    createdByName: 'System',
    createdAt: daysAgo(14),
    updatedByName: null,
    updatedAt: null,
  },
  {
    noteId: 9010,
    entityType: 'dispute',
    entityId: 19,
    entityReference: 'DSP-019',
    customerId: 5,
    customerName: 'Soylent Foods',
    customerAccountNumber: 'ACC-1005',
    noteType: 'general',
    content: 'Awaiting signed goods return note before the dispute can progress.',
    isPrivate: false,
    isPinned: false,
    createdByUserId: 13,
    createdByName: 'Emma Wright',
    createdAt: daysAgo(18),
    updatedByName: null,
    updatedAt: null,
  },
];
